import { render } from "./LeadsList.vue?vue&type=template&id=58809486"
import script from "./LeadsList.vue?vue&type=script&lang=js"
export * from "./LeadsList.vue?vue&type=script&lang=js"

import "./LeadsList.vue?vue&type=style&index=0&id=58809486&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__